import { Input, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { SharedRoutingModule } from './shared-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router'; // IMPORTANTE: Necessário para routerLink e routerLinkActive
import { FileUploadModule } from 'ng2-file-upload';

// Shared Entities - Port
import { PortFormComponent } from './modules/entities/port/port-form/port-form.component';
import { PortListModalComponent } from './modules/entities/port/port-list-modal/port-list-modal.component';
import { PortModalComponent } from './modules/entities/port/port-modal/port-modal.component';
import { TerminalFormComponent } from './modules/entities/port/port-modal/terminal/terminal-form/terminal-form.component';
import { TerminalListComponent } from './modules/entities/port/port-modal/terminal/terminal-list/terminal-list.component';
import { TerminalListModalComponent } from './modules/entities/port/port-modal/terminal/terminal-list-modal/terminal-list-modal.component';
import { BerthFormComponent } from './modules/entities/port/port-modal/berth/berth-form/berth-form.component';
import { BerthListComponent } from './modules/entities/port/port-modal/berth/berth-list/berth-list.component';

// Shared Entities - Vessel
import { VesselModalComponent } from './modules/entities/vessel/vessel-modal/vessel-modal.component';
import { VesselListModalComponent } from './modules/entities/vessel/vessel-list-modal/vessel-list-modal.component';
import { VesselFinderConfirmComponent } from './modules/entities/vessel/vessel-finder-confirm/vessel-finder-confirm.component';
import { VesselImoSearchComponent } from './modules/entities/vessel/vessel-imo-search/vessel-imo-search.component';

// Components
import { CardHoverEffectComponent } from './components/card-hover-effect/card-hover-effect.component';
import { HomecardComponent } from './components/homecard/homecard.component';
import { MessageComponent } from './components/message/message.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DocumentInputAreaComponent } from './components/document-input-area/document-input-area.component';
import { DocumentProcessingProgressComponent } from './components/document-processing-progress/document-processing-progress.component';
import { DocumentReportPreviewComponent } from './components/document-report-preview/document-report-preview.component';
import { TimeLineComponent } from './components/time-line/time-line/time-line.component';
import { ChartDashboardComponent } from './components/chart-dashboard/chart-dashboard.component';
import { CustomAccordionComponent } from './components/custom-accordion/custom-accordion.component';
import { ListboxComponent } from './components/listbox/listbox.component';
import { TableComponent } from './components/table/table.component';
import { EditableTableComponent } from './components/editable-table/editable-table.component';
import { EditableTableRowComponent } from './components/editable-table/editable-table-row/editable-table-row.component';
import { PaginationSummaryComponent } from './components/pagination-summary/pagination-summary.component';
import { TextInputComponent } from './components/_forms/text-input/text-input.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component'; // <--- Importar
import { InputTextModule } from 'primeng/inputtext';
import { ModalWrapperModule } from './components/modal-wrapper/modal-wrapper.module';
import { SelectModule } from 'primeng/select'; // <--- 1. IMPORTAR ESTE MÓDULO
import { AutoCompleteModule } from 'primeng/autocomplete'; // <--- Importe isso
import { RolePickerComponent } from './components/role-picker/role-picker.component';
// Pipes
import { SafePipe } from './pipes/safe.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { FlagEmojiPipe } from './pipes/flag-emoji.pipe';
import { PhonePipe } from './pipes/phone.pipe';
import { DirectivesModule } from './directives/directives.module';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { Menu } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog'; // <--- ADICIONADO (Corrige 'p-dialog')
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { UnsavedChangesComponent } from './components/unsaved-changes/unsaved-changes.component';
import { FilePreviewModalComponent } from './components/file-preview-modal/file-preview-modal.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PaginatorModule } from 'primeng/paginator';
import { AppToastComponent } from './components/app-toast/app-toast.component';
//INPUTS
import { CustomDatepickerComponent } from './components/inputs/custom-datepicker/custom-datepicker.component';
import { InputModalSelectComponent } from './components/inputs/input-modal-select/input-modal-select.component';
import { InputDropdownComponent } from './components/inputs/input-dropdown/input-dropdown.component';
import { InputTextComponent } from './components/inputs/input-text/input-text.component';
import { InputNumberComponent } from './components/inputs/input-number/input-number.component';
import { InputDropdownSearchComponent } from './components/inputs/input-dropdown-search/input-dropdown-search.component';
import { InputMultiselectComponent } from './components/inputs/input-multiselect/input-multiselect.component';
import { InputCheckboxComponent } from './components/inputs/input-checkbox/input-checkbox.component';
import { InputRadioGroupComponent } from './components/inputs/input-radio-group/input-radio-group.component';
import { VoucherListComponent } from './components/voucher-list/voucher-list.component';
import { AuditHistoryModalComponent } from './components/audit-history-modal/audit-history-modal.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabsModule } from 'primeng/tabs';
import { EntityExternalRefsFormComponent } from './components/entity-external-refs-form/entity-external-refs-form.component';
import { EntityPanelComponent } from './components/entity-panel/entity-panel.component';
import { CallTimelineComponent } from './components/call-timeline/call-timeline.component';
import { AdvancedFilterComponent } from './components/advanced-filter/advanced-filter.component';
import { ListToolbarComponent } from './components/list-toolbar/list-toolbar.component';
import { FinpacStatusButtonComponent } from './components/finpac-status-button/finpac-status-button.component';
import { PopoverModule } from 'primeng/popover';

@NgModule({
  declarations: [
    CardHoverEffectComponent,
    HomecardComponent,
    SafePipe,
    MessageComponent,
    FileUploadComponent,
    DocumentInputAreaComponent,
    DocumentProcessingProgressComponent,
    DocumentReportPreviewComponent,
    CustomAccordionComponent,
    ListboxComponent,
    TableComponent,
    EditableTableComponent,
    EditableTableRowComponent,
    TimeLineComponent,
    InputDropdownComponent,
    InputModalSelectComponent,
    FooterComponent,
    SearchPipe,
    ChartDashboardComponent, // 2. Add to declarations
    SortPipe,
    FlagEmojiPipe,
    PhonePipe,
    PaginationSummaryComponent,
    SidebarComponent,
    HeaderComponent,
    ConfirmationModalComponent,
    AuditHistoryModalComponent,
    UnsavedChangesComponent,
    FilePreviewModalComponent,
    PdfViewerComponent,
    RolePickerComponent,
    CustomDatepickerComponent,
    AppToastComponent,
    InputTextComponent,
    InputNumberComponent,
    InputCheckboxComponent,
    InputRadioGroupComponent,
    InputDropdownSearchComponent,
    InputMultiselectComponent,
    VoucherListComponent,
    EntityExternalRefsFormComponent,
    // Shared Entities - Port
    PortFormComponent,
    PortListModalComponent,
    PortModalComponent,
    TerminalFormComponent,
    TerminalListComponent,
    TerminalListModalComponent,
    BerthFormComponent,
    BerthListComponent,
    // Shared Entities - Vessel
    VesselModalComponent,
    VesselListModalComponent,
    VesselFinderConfirmComponent,
    VesselImoSearchComponent,
    // Entity Panel
    EntityPanelComponent,
    // Call Timeline
    CallTimelineComponent,
    AdvancedFilterComponent,
    ListToolbarComponent,
    FinpacStatusButtonComponent,
  ],
  imports: [
    TooltipModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedRoutingModule,
    FileUploadModule,
    DirectivesModule,
    TextInputComponent,
    NgChartsModule,
    TableModule,
    ButtonModule,
    CheckboxModule,
    Menu,
    SkeletonModule,
    InputTextModule,
    SelectModule,
    AutoCompleteModule,
    MultiSelectModule,
    PaginatorModule,
    DialogModule,
    DynamicDialogModule,
    TabsModule,
    NgxExtendedPdfViewerModule,
    ModalWrapperModule,
    PopoverModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HomecardComponent,
    TableComponent,
    EditableTableComponent,
    SortPipe,
    SearchPipe,
    FlagEmojiPipe,
    PhonePipe,
    DirectivesModule,
    CardHoverEffectComponent,
    SafePipe,
    MessageComponent,
    FileUploadComponent,
    DocumentInputAreaComponent,
    DocumentProcessingProgressComponent,
    DocumentReportPreviewComponent,
    TimeLineComponent,
    CustomAccordionComponent,
    ListboxComponent,
    FileUploadModule,
    PaginationSummaryComponent,
    TextInputComponent,
    FooterComponent,
    SidebarComponent,
    ConfirmationModalComponent,
    AuditHistoryModalComponent,
    SkeletonModule,
    HeaderComponent,
    ModalWrapperModule,
    UnsavedChangesComponent,
    FilePreviewModalComponent,
    PdfViewerComponent,
    InputDropdownComponent,
    ChartDashboardComponent, // 3. Add to exports
    InputModalSelectComponent,
    NgChartsModule,
    RolePickerComponent,
    CustomDatepickerComponent,
    AppToastComponent,
    InputTextComponent,
    InputNumberComponent,
    InputCheckboxComponent,
    InputRadioGroupComponent,
    InputDropdownSearchComponent,
    InputMultiselectComponent,
    VoucherListComponent,
    EntityExternalRefsFormComponent,
    // Shared Entities - Port
    PortFormComponent,
    PortListModalComponent,
    PortModalComponent,
    TerminalFormComponent,
    TerminalListComponent,
    TerminalListModalComponent,
    BerthFormComponent,
    BerthListComponent,
    // Shared Entities - Vessel
    VesselModalComponent,
    VesselListModalComponent,
    VesselFinderConfirmComponent,
    VesselImoSearchComponent,
    // Entity Panel
    EntityPanelComponent,
    // Call Timeline
    CallTimelineComponent,
    AdvancedFilterComponent,
    ListToolbarComponent,
    FinpacStatusButtonComponent,
  ],
  providers: [DatePipe],
})
export class SharedModule {}
